module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element', {
		init: function () {
			this.emptyValue = '';
			this.formElement = true;
			this.value = '';
			this.visual = false;
			this.isDisabled = false;

			this.form = this.getParent();
			this._setElement(this.options.elems);
			//this._updateHandler();
		},

		_updateHandler: function() {
			if (this.options.autoApply) {
				this.addDomHandler({target: this.formElement, event:'change', callback: 'changeHandler'}, 'changed');
			}
		},

		running: function() {
			this.handleEvent(this.form, 'elementsUpdated', fox.bind(this.onElementsUpdated, this));
		},

		onElementsUpdated: function() {
			var elems = this.form.getFormElement(this.alias);

			if (elems) {
				this._setElement(elems);
			}

			this._updateHandler();
			this._updateValue();
		},

		_updateValue: function() {
			this._setValue(this.value);
			return;
		},

		_setElement: function(elems) {
			if (!elems.length) {
				return false;
			}
			
			this.formElement = elems[0];
			
			if (!this.formElement.value.length) {
				this.formElement.value = this.value;
			}
		},

		changeHandler: function(elt, alias, scope, e) {
			this.setValue(this.getValue());
		},

		setValue: function (val, noLog) {
			if (typeof val == 'undefined') {
				val = '';
			}

			this._setValue(val);
			this.value = val;
			this.dispatchEvent('valueChanged', this);
			this.dispatchEvent('changed', this);
			this.form._setValue(this.getAlias(), val, noLog);
			return this;
		},

		_setValue: function (val) {
			this.formElement.value = val;
		},

		setValueCallback: function(val) {
			this.setValue(val);
		},

		getValue: function () {
			return this.formElement && this.formElement.value;
		},

		disable: function () {
			this.formElement.disabled = true;
			this.isDisabled = true;
			this.dispatchEvent('disabled', this);
			return this;
		},

		enable: function () {
			this.formElement.disabled = false;
			this.isDisabled = false;
			this.dispatchEvent('enabled', this);
			return this;
		},

		readonly: function (state) {
			var state = (typeof state == 'undefined' ? true : state);
			this.formElement.readOnly = state;
			return this
		}
	});
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/form/element.js
// module id = 188
// module chunks = 0